import { Check, Filter, X, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

const OUTCOME_ICON_BG: Record<string, string> = {
  Processed: 'bg-green-500/20 text-green-400',
  Filtered: 'bg-amber-500/20 text-amber-400',
  Failed: 'bg-red-500/20 text-red-400',
  Skipped: 'bg-gray-500/20 text-gray-400',
};

export function OutcomeIcon({ outcome }: { outcome: string }) {
  const cls = OUTCOME_ICON_BG[outcome] ?? 'bg-gray-500/20 text-gray-400';
  const Icon =
    outcome === 'Processed' ? Check :
    outcome === 'Filtered' ? Filter :
    outcome === 'Failed' ? X :
    Minus;

  return (
    <span
      title={outcome}
      className={cn('inline-flex h-5 w-5 items-center justify-center rounded-full shrink-0', cls)}
    >
      <Icon className="h-3 w-3" />
    </span>
  );
}
